import { useMemo } from "react";

export const useJalaliConverter = (gregorianDate?: string | null) => {
  const convertedDate = useMemo(() => {
    if (!gregorianDate) return "";

    const date = new Date(gregorianDate);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };

    return new Intl.DateTimeFormat("fa-IR", options).format(date);
  }, [gregorianDate]);

  return convertedDate;
};
